"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var mui_1 = require("tss-react/mui");
var mobx_react_1 = require("mobx-react");
var ArrowDropDown_1 = __importDefault(require("@mui/icons-material/ArrowDropDown"));
var Menu_1 = __importDefault(require("./Menu"));
var useStyles = (0, mui_1.makeStyles)()(function (theme) {
  return {
    buttonRoot: {
      '&:hover': {
        backgroundColor: (0, material_1.alpha)(theme.palette.primary.contrastText, theme.palette.action.hoverOpacity),
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    }
  };
});
function DropDownMenu(_ref) {
  var menuTitle = _ref.menuTitle,
    session = _ref.session,
    menuItems = _ref.menuItems;
  var _ref2 = (0, react_1.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    open = _ref3[0],
    setOpen = _ref3[1];
  var anchorEl = (0, react_1.useRef)(null);
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  function handleToggle() {
    setOpen(!open);
  }
  function handleMenuItemClick(_event, callback) {
    callback(session);
    handleClose();
  }
  function handleClose() {
    setOpen(false);
  }
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(material_1.Button, {
    ref: anchorEl,
    onClick: handleToggle,
    color: "inherit",
    "data-testid": "dropDownMenuButton",
    classes: {
      root: classes.buttonRoot
    }
  }, menuTitle, react_1.default.createElement(ArrowDropDown_1.default, null)), react_1.default.createElement(Menu_1.default, {
    anchorEl: anchorEl.current,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    onMenuItemClick: handleMenuItemClick,
    open: open,
    onClose: handleClose,
    menuItems: menuItems
  }));
}
exports.default = (0, mobx_react_1.observer)(DropDownMenu);